// Workaround for Chrome bug 508306805: mouse wheel changes the value of
// <input type="number"> on scroll. Capture-phase listener short-circuits the
// default action whenever a wheel event lands on a numeric input.
export function install_number_input_wheel_guard(target: Document = document): void {
  target.addEventListener(
    'wheel',
    (event: WheelEvent) => {
      const t = event.target
      if (t instanceof HTMLInputElement && t.type === 'number') {
        event.preventDefault()
      }
    },
    { passive: false, capture: true }
  )
}
